module.exports = __webpack_public_path__ + "static/media/Ulol2.366554c5.png";